/**
 * ---------------------------------------------------
 *  GET USUÁRIOS DO SISTEMA
 * ---------------------------------------------------
 */
export const GET_USERS_REQUEST = '@users/GET_USERS_REQUEST';
export const GET_USERS_SUCCESS = '@users/GET_USERS_SUCCESS';
export const GET_USERS_FAILURE = '@users/GET_USERS_FAILURE';

/**
 * ---------------------------------------------------
 *  CADASTRO DE INSTITUIÇÃO
 * ---------------------------------------------------
 */
export const NEW_USERS_REQUEST = '@users/NEW_USERS_REQUEST';
export const NEW_USERS_SUCCESS = '@users/NEW_USERS_SUCCESS';
export const NEW_USERS_FAILURE = '@users/NEW_USERS_FAILURE';
